import { PATHS } from "@constants/Paths";
/**
 * Data-rich routes that assume a wide viewport. The browse + buy funnel
 * (home, new-report, checkout, report-type) is intentionally left open so it is
 * never blocked on mobile. Retire entries here as each view becomes responsive.
 */
export const GATED_ROUTES = [
    { path: PATHS.OVERVIEW, hardBlock: true },
    { path: PATHS.RESULTS, hardBlock: true },
    { path: PATHS.COMMUNITY, hardBlock: true },
    { path: PATHS.REPORT_SETTINGS, hardBlock: true },
    { path: PATHS.ADMIN_DASHBOARD, hardBlock: true },
];
const toMatcher = (template) => new RegExp(`^${template.replace(/:[^/]+/g, "[^/]+").replace(/\//g, "\\/")}\\/?$`);
/** Returns the gate config for a pathname, or `null` when the route is not gated. */
export const matchGatedRoute = (pathname) => { var _a; return (_a = GATED_ROUTES.find((route) => toMatcher(route.path).test(pathname))) !== null && _a !== void 0 ? _a : null; };
